import forms from "./forms";
import buttons from "./buttons";
import nut from "./nut";
import channel from "./channel";
import dict from "./dict";
import term from "./term";
import group from "./group";
import article from "./article";
import utilities from "./utilities";
import blog from "./blog";
import setting from "./setting";
import auth from "./auth";
import course from "./course";
import message from "./message";
import label from "./label";
const items = {
  "columns.library.title": "Library",
  "columns.library.home.title": "Home",
  "columns.library.community.title": "Community",
  "columns.library.palicanon.title": "Palicanon",
  "columns.library.course.title": "Course",
  "columns.library.term.title": "Term",
  "columns.library.dict.title": "Dictionary",
  "columns.library.anthology.title": "Anthology",
  "columns.library.help.title": "Help",
  "columns.library.more.title": "More",
  "columns.library.calendar.title": "Calendar",
  "columns.library.convertor.title": "Script Convertor",
  "columns.library.palihandbook.title": "Pali-handbook",
  "columns.library.statistics.title": "Statistics",
  "columns.library.blog.label": "Blog",
  "columns.studio.title": "Studio",
  "columns.studio.palicanon.title": "Palicanon",
  "columns.studio.recent.title": "Recent",
  "columns.studio.channel.title": "Channel",
  "columns.studio.group.title": "Group",
  "columns.studio.userdict.title": "Dictionary",
  "columns.studio.term.title": "Term",
  "columns.studio.course.title": "Course",
  "columns.studio.article.title": "Article",
  "columns.studio.anthology.title": "Anthology",
  "columns.studio.analysis.title": "Analysis",
  "columns.studio.collaboration.title": "Collaboration",
  "columns.studio.basic.title": "Basic",
  "columns.studio.advance.title": "Advance",
  "columns.studio.setting.title": "Setting",
  "columns.exp.title": "Exp",
  "columns.studio.invite.title": "Invite",
  "columns.studio.transfer.title": "Transfer",
  "columns.studio.attachment.title": "Attachment",
  "columns.studio.tag.title": "Tag",
  ...buttons,
  ...forms,
  ...nut,
  ...channel,
  ...dict,
  ...term,
  ...group,
  ...article,
  ...utilities,
  ...blog,
  ...setting,
  ...auth,
  ...course,
  ...message,
  ...label,
};

export default items;
